import React from "react";
import type { ISvgProps } from "@/types";

export const RidersIcon: React.FC<ISvgProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width || "1em"}
      height={height || "1em"}
      viewBox="0 0 34 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.1779 25.036L24.4797 0.947805C24.3753 0.646269 24.1202 0.437512 23.8071 0.367927C12.9865 -1.73123 2.46754 5.36648 0.368376 16.187C-1.73078 27.0075 5.35533 37.5265 16.1759 39.6373C17.44 39.8808 18.7389 40.0084 20.0147 40.0084C20.1422 40.0084 20.2698 40.0084 20.409 40.0084C20.6757 40.0084 20.9309 39.8692 21.1048 39.6605C21.2672 39.4401 21.3252 39.1618 21.2672 38.9066L19.5971 32.0757C20.0379 31.7162 20.3162 31.1711 20.3162 30.5796C20.3162 29.5126 19.4232 28.6544 18.333 28.6544C17.208 28.6544 16.3614 29.5126 16.3614 30.6144C16.3614 31.5422 16.9761 32.2844 17.8575 32.4816C17.8575 32.4932 17.8575 32.4932 17.8575 32.5048L19.2492 38.2108C18.333 38.176 17.4284 38.06 16.5238 37.8861C6.66586 35.9609 0.20601 26.3813 2.11961 16.5349C4.01001 6.83937 13.2997 0.437513 22.972 2.04957L31.2527 24.978L27.5531 27.3439C26.173 25.929 22.3458 22.2525 19.0405 21.4291C17.498 21.0464 16.547 19.8054 16.0251 18.8197C15.654 18.1238 15.422 17.4395 15.2828 16.8713C15.8395 16.5233 16.2107 15.9087 16.2107 15.2244C16.2107 14.1574 15.3176 13.2992 14.2275 13.2992C13.1025 13.2992 12.2559 14.1574 12.2559 15.2592C12.2559 16.0942 12.7546 16.7669 13.4852 17.0452C13.636 17.7643 13.8911 18.5065 14.1811 19.156C15.1669 21.2783 16.7325 22.7048 18.5998 23.1687C22.1022 24.0386 26.6949 29.0487 26.7412 29.0951C27.0312 29.4198 27.5183 29.4778 27.8894 29.2459L32.8184 26.1029C33.1779 25.871 33.3171 25.4303 33.1779 25.036Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-0.00274621"
          y1="20.0081"
          x2="33.2333"
          y2="20.0081"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
      </defs>
    </svg>
  );
};
